import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=522190bd&"
import script from "./DownloadReport.vue?vue&type=script&lang=ts&"
export * from "./DownloadReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VCheckbox,VContent})
